import home from './home';
import web from './web';
import shop from './shop';

export default [
    ...home,
    ...web,
    ...shop
];
